import React from 'react';
import PropTypes from 'prop-types';
import { __ } from 'i18n-for-browser';

class GroupGameScoreRow extends React.Component {
  static propTypes = {
    text: PropTypes.string,
    color: PropTypes.string,
    gameScores: PropTypes.array,
    isPoints: PropTypes.bool,
    editable: PropTypes.bool,
    bonus: PropTypes.bool,
    score: PropTypes.shape({
      globas: PropTypes.number,
      points: PropTypes.number,
    }),
    onChange: PropTypes.func,
  };
  static defaultProps = {
    text: '',
    color: 'red',
    gameScores: [],
    bonus: false,
    editable: false,
    isPoints: false,
    onChange: () => { },
    score: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      score: {},
    };
  }

  onGameScoreChange = (ev) => {
    this.props.onChange(ev.target.value);
  };

  render() {
    const { text, color, gameScores, score, isPoints, bonus, editable } = this.props;
    gameScores.sort((a, b) => b.points - a.points);
    const { points, globas } = score;
    return (
      <div className={`group-row game-score ${color}`}>
        <div className={'ranking-row-inner'}>
          <div>
            <span>{text}</span>
          </div>
          <div>
            {points !== undefined && globas !== undefined && !editable ? (
              <span className="score">{bonus ? points : globas}</span>
            ) : (
              <select name="gameScore" onChange={this.onGameScoreChange} value={points !== undefined && globas !== undefined ? JSON.stringify({ points, globas }) : 0}>
                <option value={0}>[{__('sim_kies_score')}]</option>
                {gameScores.map(gs => (<option key={gs.id} value={JSON.stringify({ points: gs.points, globas: gs.globas })}>{isPoints ? gs.points : gs.globas}</option>))}
              </select>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default GroupGameScoreRow;



// WEBPACK FOOTER //
// ./src/components/elements/GroupGameScoreRow.js